import { ErrorType } from "domain/error";
import { Button, Col } from "reactstrap";
import { brand } from "services/envService";
import { redirectTo } from "util/redirect";
import { Heading, HeadingTag } from "../common/Heading";
import {
  CONTACT_US_TEXT_2,
  CONTACT_US_TEXT_3,
  CONTACT_US_TEXT_4,
  CONTACT_US_TEXT_4_LINK_TEXT,
  RELAY_UK_CALL_CODE,
  CALL_CHARGE_INF_LINKS,
  APPLICATION_CANCELLED_TEXT,
  BUSINESS_LINES,
  CONTACT_US_TEXT_1,
  EXIT_BUTTON_TEXT,
  BOUNCE_BACK_LOAN_LINKS,
} from "./HardStops.const";

type ContactUsProps = {
  header: string;
  toptext: string;
  errorType: ErrorType;
};

const BRAND = brand();
const onButtonClick = () => redirectTo(BOUNCE_BACK_LOAN_LINKS[BRAND]);

export const ContactUs = (props: ContactUsProps) => {
  return (
    <Col className="content-body">
      <div className="hardStop-container">
        <div className="hardStop-content-wrapper">
          <Heading
            size={1}
            tag={HeadingTag.h1}
            className="zb-heading1 screen-header"
            title={props.header}
          >
            <span className="hardStop-message">
              {props.toptext}
              <b className="highlighted">&nbsp;{BUSINESS_LINES[BRAND]}</b>
              &nbsp;{CONTACT_US_TEXT_1}
              <br />
              <p className="newline">
                {CONTACT_US_TEXT_2}&nbsp;
                <b className="highlighted">
                  {RELAY_UK_CALL_CODE} {BUSINESS_LINES[BRAND]}
                </b>
              </p>
              <p className="newline">{CONTACT_US_TEXT_3}</p>
              <br />
              {CONTACT_US_TEXT_4}&nbsp;
              <a
                rel="noreferrer"
                target="_blank"
                href={CALL_CHARGE_INF_LINKS[BRAND]}
              >
                {CONTACT_US_TEXT_4_LINK_TEXT}
              </a>
              {"."}
            </span>
            <br />
            <p className="hardStop-message newline">
              {APPLICATION_CANCELLED_TEXT}
            </p>
          </Heading>
          <div className="hardStop-button-container">
            <Button size="lg" color="primary" onClick={onButtonClick}>
              {EXIT_BUTTON_TEXT}
            </Button>
          </div>
        </div>
      </div>
    </Col>
  );
};
